import { BaseModel } from '~/models/baseModel';

export class OfferStatModel extends BaseModel {
    public average:number;
    public low:number;
    public high:number;
}